import { PropertyType } from 'esa-ui-library/lib/types';
import { isEmpty } from 'lodash';

export const getErrorMessage = (field: string): string => `${field} is required`;

export const validateForm = (form: PropertyType): PropertyType | null => {
	const errors: PropertyType = {};

	if (!form.campaign_name) {
		errors.campaign_name = getErrorMessage('Campaign name');
	}

	// if (!form.campaign_rules) {
	// 	errors.campaign_rules = getErrorMessage('Rules');
	// }

	if (!form.campaign_description) {
		errors.campaign_description = getErrorMessage('Campaign description');
	}

	if (!form.status || (Array.isArray(form.status) && form.status.length === 0)) {
		errors.status = getErrorMessage('Status');
	}

	if (!form.partners || (Array.isArray(form.partners) && form.partners.length === 0)) {
		errors.partners = getErrorMessage('Partners');
	}

	if (!form.from_date) {
		errors.from_date = getErrorMessage('Start date');
	}
	if (!form.to_date) {
		errors.to_date = getErrorMessage('End date');
	}

	if (!form.device || (Array.isArray(form.device) && form.device.length === 0)) {
		errors.device = getErrorMessage('Device');
	}

	if (!form.money_drop_currency) {
		errors.money_drop_currency = getErrorMessage('Money drop currency');
	}

	if (!form.all_games && (!form.games || form.games.length === 0)) {
		errors.games = getErrorMessage('Games');
	}

	return !isEmpty(errors) ? errors : null;
};
